import { ModelType } from '@livv/models';
import { FC, ReactNode } from 'react';
import { useArticleLink } from '../../utils/hooks';
import useAmplitude from '@utils/hooks/useAmplitude';
import { TrackingEventName } from '@utils/types/amplitude/events';

interface ArticleLinkProps {
    articleId: string;
    children: ReactNode;
    isInFirestore?: boolean;
    label: string;
}

const ArticleLink: FC<ArticleLinkProps> = ({ articleId, children, isInFirestore, label }) => {
    const { link } = useArticleLink(articleId, label, isInFirestore);
    const { track } = useAmplitude();

    const handleClick = () => {
        track({
            name: TrackingEventName.BODY_EXTRA_CONTENT_CLICKED,
            params: {
                target_document_id: articleId,
                target_document_type: ModelType.ARTICLE,
            },
        });
    };

    return (
        <a href={link} onClick={handleClick} rel="noopener noreferrer" target="_blank">
            {children}
        </a>
    );
};

export default ArticleLink;
